import $ from 'jquery';
import imagesLoaded from 'imagesloaded';
import Flickity from 'flickity';


const carousel = function (options) {
    let o, m, flickityDefaults, internal, elements, fn, handlers;


    o = $.extend({
        $e: null,
        selector: '',
        flickityOpts: {}
    }, options);


    m = carousel.markup;


    flickityDefaults = {
        cellSelector: `.${m.SLIDE}`,
        cellAlign: 'left',
        groupCells: true,
        pageDots: false,
        prevNextButtons: false
    };


    internal = {
        $e: o.$e || $(o.selector),
        flickityOpts: Object.assign(flickityDefaults, o.flickityOpts),
        flkty: null
    };


    elements = {
        prev: internal.$e.find(`.${m.PREV}`),
        next: internal.$e.find(`.${m.NEXT}`)
    };


    fn = {
        init () {
            imagesLoaded(internal.$e[0], function () {
                internal.flkty = new Flickity(internal.$e[0], internal.flickityOpts);
                internal.$e.addClass(m.SETUP);
            });

            elements.prev.on('click.carousel', handlers.prevClick);
            elements.next.on('click.carousel', handlers.nextClick);
        },

        prev () {
            internal.flkty.previous();
        },

        next () {
            internal.flkty.next();
        },

        destroy () {
            internal.flkty.destroy();
            Object.keys(elements).forEach(el => elements[el].off('.carousel'));
        }
    };


    handlers = {
        prevClick (e) {
            fn.prev();
            e.preventDefault();
        },

        nextClick (e) {
            fn.next();
            e.preventDefault();
        }
    };


    fn.init();
};


carousel.markup = {
    // dom selector
    CONTAINER: 'carousel',
    SLIDE: 'carousel__slide',
    PREV: 'carousel__button--prev',
    NEXT: 'carousel__button--next',

    // states
    SETUP: 'state-setup'
};


export default carousel;



// WEBPACK FOOTER //
// ./assets/js/components/carousel.js